import React, {PropTypes} from 'react';
import {Button, Icon} from '@goguardian/based';
import {Link} from 'react-router';
import cn from 'classnames';

import style from './style.scss';

export default class Finish extends React.Component {

  render() {
    const developerTools = cn([style.developerTools], [style.imageWindow]);
    const extensions = cn([style.extensions], [style.imageWindow]);
    const incognitoMode = cn([style.incognitoMode], [style.imageWindow]);

    return (
      <div className={style.step}>
        <div className={style.stepHeader}>
          <Link to="/getting-started/deploy"><Icon value="arrow-left"/></Link>

          <h1>Step 5 of 5</h1>
          <h2>Finish</h2>
        </div>

        <div className={style.stepContent}>
          <div className={style.figureContent}>
            <p>Under Developer Tools select <br /> <strong>Never allow use of built-in developer tools</strong>
              <Icon value="arrow-down"/>
            </p>
            <div className={style.figureContain}>
              <div className={developerTools}></div>
            </div>
          </div>

          <div className={style.figureContent}>
            <p>Confirm that you allow <strong>Extensions</strong> for your users
              <Icon value="arrow-down"/>
            </p>
            <div className={style.figureContain}>
              <div className={extensions}></div>
            </div>
          </div>

          <div className={style.figureContent}>
            <p>Under Incognito Mode select <br /> <strong>Disallow incognito mode</strong></p>
            <div className={style.figureContain}>
              <div className={incognitoMode}></div>
            </div>
          </div>


          <Link to="/getting-started/end"><Button block>Finish</Button></Link>
        </div>
      </div>
    );
  }
};



/** WEBPACK FOOTER **
 ** ./src/app/components/gettingStarted/finish/index.jsx
 **/